import { TDevice } from '../entities/ric003'
import { DataSource } from 'typeorm'
import { convertToDeviceData } from './utils'
import { Devices } from '../common'

export async function loadDevices(dataSource: DataSource, sigfoxIds: string[]) {
  const devices: Devices = {}
  const repository = dataSource.getRepository(TDevice)

  for (var i = 0; i < sigfoxIds.length; i++) {
    const sigfoxId = sigfoxIds[i]

    if (!devices[sigfoxId]) {
      // [ALR] side-effect
      const deviceData = await repository.findOneBy({
        WISOL_ID: sigfoxId,
      })

      if (deviceData) {
        devices[sigfoxId] = convertToDeviceData(deviceData)
      }
    }
  }

  return devices
}
